import { render, staticRenderFns } from "./sk-checkbox-img.vue?vue&type=template&id=2d2c613d&scoped=true&"
import script from "./sk-checkbox-img.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox-img.vue?vue&type=script&lang=js&"
import style0 from "./sk-checkbox-img.vue?vue&type=style&index=0&id=2d2c613d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c613d",
  null
  
)

export default component.exports